export default __webpack_public_path__ + "static/media/lines-splines.1d543e37.jpg";